<template>
  <div class="app-container" style="padding:30px 100px;">
    <el-form :model="data" ref="addForm" label-width="90px">
      <el-form-item label="文章标题:" prop="name">{{data.title}}</el-form-item>
      <el-form-item label="类型:" prop="name">{{data.contentType === 1 ? '图文' : '视频'}}</el-form-item>
      <el-form-item label="封面图:" prop="name">
        <el-image v-for="item in data.headPicUrlList" style="width: 100px;margin-right: 5px"
                  :src="item" :preview-src-list="[item]" fit="contain"/>
      </el-form-item>
      <el-form-item label="列表排版:" v-if="data.articleType === 1 && data.contentType === 1" prop="name">{{data.listStyleDesc}}</el-form-item>
      <el-form-item label="视频文件:" prop="name" v-if="data.contentType === 2">
        <video v-if="data.videoUrl" controls="controls" preload  style="width: 300px; height: 300px;background:#eee;">
          <source :src="data.videoUrl" type=".mp4,.mov,.avi,.flv">
        </video>
      </el-form-item>
      <el-form-item label="标签:" v-if="data.articleType === 1" prop="name">{{data.tags}}</el-form-item>
      <el-form-item label="文章详情:" prop="content" v-if="data.contentType === 1">
        <el-card shadow="never">
          <div v-html="data.content"></div>
        </el-card>
      </el-form-item>
      <el-form-item label="简介:" prop="introduction" v-if="data.contentType === 2">
        {{data.introduction}}
      </el-form-item>
      <el-form-item prop="introduction">
        <el-button @click="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { companyArticleDetail } from "@/api/saas/package";
import { mapState } from 'vuex'
export default {
  components: {
  },
  data() {
    return {
      articleId: null,
      data: {}
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  mounted() {
    this.articleId = this.$route.query.id;
    this.companyArticleDetail();
  },
  methods: {
    companyArticleDetail() {
      companyArticleDetail({ articleId: this.articleId })
        .then(response => {
          this.data = response.data || {};
        })
        .catch(error => {});
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
